// extracted by mini-css-extract-plugin
export default {"tooltip":"Tooltip_tooltip__sqcUG","safariEllips":"Tooltip_safariEllips__gu5ba"};